module.exports = __webpack_public_path__ + "static/media/nine.24b8ba2f.png";